import { useQuery } from '@tanstack/react-query';

import { companyQueryOptions } from './query-options';

export const useGetAvailableCompaniesQuery = () =>
    useQuery(companyQueryOptions.getAvailableCompaniesQueryOptions());
